import { useEffect, useState } from "react";
import { Button, Grid, MenuItem, Paper, TextField, Typography } from "@mui/material";
import MapContainer from '../../../components/map';
import SaveIcon from '@mui/icons-material/Save';
import AuxAlert from "../../../components/alert";
import { GetDatos, GetRegionAndCities, UpdateCoordenadas } from "../../../controllers/company/CompanyProfileController";
import { LoadingButton } from "@mui/lab";
import GooglePlacesAutocomplete, { geocodeByLatLng } from "react-google-places-autocomplete";

export default function Ubicacion(props)
{
    const [address,setAddress] = useState('');
    const [errorAddress,setErrorAddress] = useState(false);
    const [coordinates,setCoordinates] = useState()
    const [center,setCenter] = useState(props.center);

    const [country,setCountry] = useState('');
    const [regions,setRegions] = useState([]);
    const [region,setRegion] = useState('');
    const [errorRegion,setErrorRegion] = useState(false);

    const [cities,setCities] = useState([]);
    const [city,setCity] = useState('');
    const [errorCity,setErrorCity] = useState(false);

    const [isLoading,setIsLoading] = useState(false);
    const [open,setOpen] =useState(false);
    const [title,setTitle] = useState('');
    const [message,setMessage] = useState('');
    const [success,setSuccess] = useState(true);

    const [isGoogleLoaded, setGoogleLoaded] = useState(false);
    useEffect(() => {
        const checkGoogleMaps = setInterval(() => {
            if (window.google) {
            setGoogleLoaded(true);
            clearInterval(checkGoogleMaps);
            }
        }, 1000);
    }, []);


    useEffect(()=>{
        getInfo();
    },[])

    const getInfo = async () => {
        let response = await GetDatos();
        if(response.success === true)
        {
            setAddress(response.data.empresa.direccion);
            setCountry(response.data.empresa.country);
            setRegion(response.data.empresa.region_id);
            setCity(response.data.empresa.city_id);

            setCoordinates({
                lat:parseFloat(response.data.empresa.lat),
                lng:parseFloat(response.data.empresa.lng)
            });
            setCenter({
                lat:parseFloat(response.data.empresa.lat),
                lng:parseFloat(response.data.empresa.lng)
            });

            getRegions(response.data.empresa.country,response.data.empresa.region_id);

        }
    }

    const getRegions = async (_country,_region='') => {
        const response = await GetRegionAndCities(_country);
        if(response.success === true){
            setRegions(response.data.regions);
            setRegion(_region);
            console.log('El RESULTADO DE REGIONS ===> ',response.data)
        }
    }

    const handleRegionChange = (regionId) => {
        // 1. Encontrar la región correspondiente en el array principal
        const selectedRegion = regions.find(region => region.region_id === regionId);

        // 2. Si se encuentra la región, actualizar los estados
        if (selectedRegion) {
            setRegion(regionId);
            setCities(selectedRegion.cities);
        } else {
            // Manejar el caso de que la región no se encuentre
            setRegion('');
            setCities([]);
        }
    };

    useEffect(()=>{
        console.log('La region ha cambiado ===> ',region);
        handleRegionChange(region);
    },[region]);



    const getAddressByLatLng = async () => {
        geocodeByLatLng({ lat: coordinates.lat, lng: coordinates.lng })
            .then(results => console.log(results))
            .catch(error => console.error(error));
    }


    const mapClicked = (mapProps, map, clickEvent) => {
        setCoordinates({lat: parseFloat(clickEvent.latLng.lat()),lng:parseFloat(clickEvent.latLng.lng())});
    }

    const formVerification = () => {
        var ban = 0;

        if(address === '')
        {
            setErrorAddress(true)
            ban = 1;
        }
        
        return ban;
    }

    const handleUpdateCoordenadas = async () => {
        if(formVerification() === 0)
        {
            setIsLoading(true);
            let response = await UpdateCoordenadas(region,city,address,coordinates);
            if(response.success === true)
            {
                setSuccess(true);
                setTitle('Operación Exitosa!');
                setMessage(response.message);
                setOpen(true);
                await setTimeout( () => 
                    setOpen(false),7000
                );
            }
            else
            {
                setSuccess(false);
                setTitle('Operación Fallida!');
                setMessage(response.message);
                setOpen(true);
            }
            setIsLoading(false);
        }
    }

    return(
        <Paper>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display='flex' flexDirection='row' justifyContent='space-between'>
                    <Typography variant='h6' sx={{fontWeight:'bold'}}>Ubicación</Typography>
                    <LoadingButton
                        loading={isLoading}
                        variant="contained"
                        startIcon={<SaveIcon />}
                        onClick={() => handleUpdateCoordenadas() }
                        //onClick={() => getAddressByLatLng()}
                    >
                        Guardar
                    </LoadingButton>
                </Grid>

                {
                    regions.length !== 0 &&
                    <>
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                            <TextField
                                fullWidth
                                disabled
                                variant="outlined"
                                label='Pais'
                                value={country}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                            <TextField
                                fullWidth
                                select
                                id="region"
                                name='region'
                                label="Region"
                                placeholder='Seleccione una region'
                                variant="outlined"
                                value = {region}
                                //onChange = { (e) => handleRegionChange(e.target.value) }
                                onChange={ (e) => setRegion(e.target.value) }
                                onBlur={ () => (region === '' ? setErrorRegion(true) : setErrorRegion(false) )  }
                                error = {errorRegion}
                                helperText={errorRegion && 'Seleccione la región de la empresa'}
                            >
                                <MenuItem value=''>Seleccione una Región</MenuItem>
                                {
                                    regions.length !== 0 &&
                                    regions.map((item)=>
                                        <MenuItem value={item.region_id}>{item.region}</MenuItem>
                                    )
                                }
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                            <TextField
                                fullWidth
                                select
                                id="city"
                                name='city'
                                label="Ciudad"
                                placeholder='Seleccione una ciudad'
                                variant="outlined"
                                value = {city}
                                onChange = { (e) => setCity(e.target.value) }
                                onBlur={ () => (city === '' ? setErrorCity(true) : setErrorCity(false) ) }
                                error = {errorCity}
                                helperText={errorCity && 'Seleccione la ciudad de la empresa'}
                            >
                                <MenuItem value=''>Seleccione una Región</MenuItem>
                                {
                                    cities.length !== 0 &&
                                    cities.map((item)=>
                                        <MenuItem value={item.city_id}>{item.name}</MenuItem>
                                    )
                                }
                            </TextField>
                        </Grid>
                    </>
                }

                


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        variant="outlined"
                        label='Dirección'
                        value={address}
                        onChange = { (e) => setAddress(e.target.value) }
                        onBlur={ () => (address === '' ? setErrorAddress(true) : setErrorAddress(false) ) }
                        error = {errorAddress}
                        helperText={errorAddress && 'Debes ingresar la dirección'}
                    />
                </Grid>
                {
                    coordinates !== undefined &&
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <MapContainer
                            center={center}
                            coordenadas={coordinates}
                            mapClicked={ (mapProps, map, clickEvent) => mapClicked(mapProps, map, clickEvent)  }
                        />
                    </Grid>
                }
                
            </Grid>
            <AuxAlert
                open={open}
                success={success}
                title={title}
                message={message}
            />
        </Paper>
    )
}